import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import { DicomSeries } from '~/domain/dicom/series';
import { showSensitiveInfoState } from '~/state/atoms/viewerAtoms';
import { formatSeriesDate } from '~/utils/date';
import { OverlayLabel } from '../../OverlayLabel';

interface ImageDetailsProps {
    metadata: DicomSeries;
    color: string;
}

const ImageDetails = ({ metadata, color }: ImageDetailsProps) => {
    const seriesDate = formatSeriesDate(metadata.seriesDate);
    const showSensitiveInfo = useRecoilValue(showSensitiveInfoState);

    return (
        <Box display="flex" gap={1} maxWidth={220}>
            <OverlayLabel color={color} flexShrink={0}>
                {metadata.modality}
            </OverlayLabel>
            <OverlayLabel
                noWrap
                sx={{
                    display: 'block',
                }}
                title={
                    showSensitiveInfo
                        ? metadata.seriesDescription || 'Unknown Series'
                        : undefined
                }
            >
                <SensitiveInfoTypography>
                    {metadata.seriesDescription || 'Unknown Series'}
                </SensitiveInfoTypography>
            </OverlayLabel>
            {seriesDate && (
                <OverlayLabel flexShrink={0}>
                    <SensitiveInfoTypography>
                        {seriesDate}
                    </SensitiveInfoTypography>
                </OverlayLabel>
            )}
        </Box>
    );
};

export default ImageDetails;
